<template>
    <div class="container mx-auto page no-top-bar">
        <TopBarDetail
            :isShowBack="true"
            @clickBack="clickBack()"
        ></TopBarDetail>
        <div class=" px-4">
                <div class=" flex">
                    <InputSearch
                    v-model:inputValue="formData"
                    class=" w-full"
                    :maxLength="50"
                    @onChange="SearchResult()"
                    ></InputSearch>
                    <div class=" ml-4">
                        <div class=" rounded-full h-11 w-11 bg-white flex items-center justify-center" @click="SearchBt()">
                            <img src="../../../assets/icon/ic-search.svg" alt=""/>
                        </div>
                    </div>
                </div>
            <div class=" py-5">
                            <CampaignList
                            ref="campaign-list"
                            :initListConfig="listConfig"
                            :initFilterConfig="filterConfig"
                            :modalController="modalController"
                            @onLoaded="onLoadSuccess('campaign')"
                ></CampaignList>
            </div>
        </div>
        <ModalMaster :controller="modalController"></ModalMaster>
    </div>
</template>

<script>
import ConfigManager from "@/config/ConfigManager.js";
//mixin
import ModalMixin from "@/mixin/ModalMixin.js";
//service
import {
    CampaignListConfigBuilder,
    CampaignListFilterConfigBuilder
} from "@/core/Campaign/config/CampaignConfigModel.js";
import TopBarDetail from '@/components/Layout/TopBar/TopBarDetail.vue';
import InputSearch from '@/module/Search/component/InputSearch.vue'
import CampaignList from '@/module/List/component/CampaignList/CampaignList.vue';
export default {
    name: 'Search',
    mixins: [ModalMixin],
    components: {
        TopBarDetail,
        InputSearch,
        CampaignList,
    },
    data: function() {
        return {
            formData: null,
            listConfig: null,
            filterConfig: null,

            loadingStatus: {
                campaign: false,
            },
        }
    },
    created: function() {
        this.initialConfig();
    },
    methods: {
        initialConfig: function(){
            this.content = this.formData
            let configStr = ConfigManager.getCampaignListDevApp();
            let listConfig = new CampaignListConfigBuilder()
                .setConfigList(configStr)
                .setTop(25)
                .setConfigList('campaign_search')
                .create();
            this.listConfig = listConfig;

            let filterConfig = new CampaignListFilterConfigBuilder()
                .setSearch(this.content)
                .create();
            this.filterConfig = filterConfig;
        },
        SearchBt: function() {
            this.initialConfig();
            this.$refs['campaign-list'].reinitList(this.listConfig, this.filterConfig);
        },
        clickBack: function() {
            this.$router.back();
        },
        loadMore: function() {
            this.$refs['campaign-list'].loadMore();
        },
        onLoadSuccess: function(api) {
            if (!this.loadingStatus[api]) {
                this.loadingStatus[api] = true;
                let found = false;
                for (let i in this.loadingStatus) {
                    if (!this.loadingStatus[i]) {
                        found = true;
                        break;
                    }
                }
                if (!found) {
                    this.loadingModal.hide();
                }
            }
        },
    }
}
</script>

